import React, { useState, useEffect } from 'react';

const Statistics = () => {
  const apiUrl = import.meta.env.VITE_API_URL;

  const [data, setData] = useState({
    heading: '',
    subtitle: '',
    bgColor: '',
    textColor: '',
    stats: [],
    numbersBgColor: '',
    numbersTextColor: '',
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/home/statistics`);
        const result = await response.json();
        setData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="relative flex flex-col items-center py-20 px-6" style={{ backgroundColor: data.bgColor, color: data.textColor }}>
      {/* Heading */}
      <div className=" mb-12 max-w-2xl">
        <h2 className="text-4xl text-center md:text-5xl font-bold" style={{ color: data.textColor }}>
          {data.heading}
        </h2>
        <p className="mt-4 text-lg md:text-xl opacity-80" style={{ color: data.textColor }}>
          {data.subtitle}
        </p>
      </div>

      {/* Stats Section - Card-based */}
      <div className="flex flex-wrap justify-center text-justify gap-6 ">
        {data.stats.map((stat, index) => (
          <div key={index} 
            className="relative w-64 h-40 flex flex-col justify-center items-center p-6 bg-white/10 backdrop-blur-md rounded-xl shadow-lg transition-transform hover:scale-105"
            style={{ backgroundColor: data.numbersBgColor }}
          >
            <div className="text-3xl font-extrabold" style={{ color: data.numbersTextColor }}>
              {stat.value}
            </div>
            <div className="mt-2 text-md font-medium" style={{ color: data.numbersTextColor }}>
              {stat.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Statistics;
